let paddlePromise = null;

function getEnv() {
    const env = (process.env.REACT_APP_PADDLE_ENV || "").toLowerCase();
    return env === "production" ? "production" : "sandbox";
}

export function getPaddle() {
    if (paddlePromise) return paddlePromise;

    paddlePromise = (async () => {
        const token = process.env.REACT_APP_PADDLE_CLIENT_TOKEN;
        if (!token) throw new Error("Missing client token");

        const { initializePaddle } = await import("@paddle/paddle-js");

        // Wrapper сам тягне Paddle.js з CDN і ініціалізує.
        const paddle = await initializePaddle({
            environment: getEnv(), // 'sandbox' | 'production'
            token,
        });

        if (!paddle) throw new Error("Failed to initialize Paddle");

        return paddle;
    })();

    return paddlePromise;
}

/**
 * Опційно для SPA: якщо ти після логіну хочеш оновлювати customer/eventCallback.
 * Paddle.Initialize лише раз, а для оновлення — Paddle.Update().
 */
export async function updatePaddle(params) {
    const paddle = await getPaddle();
    if (typeof paddle.Update === "function") {
        paddle.Update(params);
    }
    return paddle;
}
